import { render, staticRenderFns } from "./ChoseCard.vue?vue&type=template&id=82174804&scoped=true"
import script from "./ChoseCard.vue?vue&type=script&lang=js"
export * from "./ChoseCard.vue?vue&type=script&lang=js"
import style0 from "./ChoseCard.vue?vue&type=style&index=0&id=82174804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82174804",
  null
  
)

export default component.exports